import React from "react";
import resume from "../docs/Prathmesh_Kurane_Resume.pdf";

export default function About() {
  const resumeDownload = () =>{
    window.open("https://drive.google.com/file/d/1Qw09sia4nURU-e98OHywHfOCQs1kzHZv/view?usp=sharing","_blank")
  }
  return (
    <div className="container-lg  mt-5" >
      <div className="row justify-content-md-center ">
        <div className="col-lg-8 mh-100 align-items-center col-sm-12">
          <div className="card text-center">
            <div className="card-body pb-5 about section" id="about">
              
              <h5 className="card-title IBM-Plex-Mono fs-3 mb-5">About</h5>
              <hr className="mb-5" />
              <p className="card-text Space-Mono"  id="user-detail-name">PRATHMESH KURANE</p>
              <p className="card-text Space-Mono"  id="user-detail-intro">
                Hello! I'm Prathmesh, a Passionate back-end developer, a Java
                enthusiast, and a guy slighty obsessed for code quality. I’m
                currently learning full stack web development. If you have a
                project that you want to get started or think you need my help
                with something, then get in touch.
              </p>
              <br />
              <button onClick={resumeDownload} id="resume-button-2" className="border-0"> 
              <a
                href={resume}
                download={resume}
                className="IBM-Plex-Mono btn btn-primary btn-hover"
                role=""
                id="resume-link-2"
              >
                Resume
              </a>
              </button>
             
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
